import React from "react";
import Stella from "../images/contenido/StellaMohme.jpg";
import StellaMohme from "../images/contenido/StellaMohmeFoto.jpg";
import HelenaMohme from "../images/contenido/HelenaMohme.jpg";
import ClaudiaCornejo from "../images/contenido/FM 2 CLAUDIA CORNEJO-SDARC-16121587.jpg";
import Familia from "../images/contenido/52 FAMILIA IMG_7785.jpg";
import Edmundo from "../images/contenido/EdmundoCruz.jpg";
import Rivero from "../images/contenido/Claudia.jpg";
import Wilber from "../images/contenido/Wilber.jpg";
import Melissa from "../images/contenido/Melissa.jpg";
import Claudia from "../images/contenido/foto cv_Mf6aL__HD_edited.jpg";
import Ricardo from "../images/contenido/Ricardo.jpg";
import Hernan from "../images/contenido/Hernan.jpg";
import Antonio from "../images/contenido/Antonio.jpg";
import Ursula from "../images/contenido/Ursula.jpg";
import Aurelio from "../images/contenido/Aurelio.jpg";
import Martin from "../images/contenido/Martin.jpg";
import Pepi from "../images/contenido/Pepi.jpg";
import Navigation from "../components/Navigation";
import { Fade } from "react-awesome-reveal";
import { Helmet } from "react-helmet";

const fundacion = () => {
  return (
    <section className="nosotros">
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          La fundación - Memoria 2014-2024 - Fundación Gustavo Mohme Llona
        </title>
        <meta
          property="og:title"
          content="La fundación - Memoria 2014-2024 - Fundación Gustavo Mohme Llona"
        />
      </Helmet>
      <div id="gustavo-mohme-llona" className="bg-white">
        <div className="container d-flex header-page">
          <div className="column-0">
            <Fade delay={100} triggerOnce>
              <br />
              <div className="pre-title">1.2</div>
              <h1 className="color-red">La fundación</h1>
              <br />
            </Fade>
          </div>
          <div className="column-0">
            <Fade delay={400} duration="2000" cascade triggerOnce>
              <div className="cont-mohme-0">
                <img
                  src={Stella}
                  alt=" Ceremonia de presentación"
                  className="mohme-0"
                />
                <div className="legend">
                  Ceremonia de presentación de la fundación el 25 de abril del
                  2014.
                </div>
                <div className="block-red"></div>
              </div>
              <div className="block-red-light"></div>
            </Fade>
          </div>
        </div>
        <div className="container">
          <div className="container-text">
            <Fade delay={100} triggerOnce damping={0.05} fraction={0} cascade>
              <div className="quote quote-center quote-red">
                <p className="">
                  La fundación es una organización autónoma que establece
                  alianzas con diversas instituciones y cuenta con el valioso
                  apoyo del Grupo La República.
                </p>
              </div>

              <p>
                Es una institución privada sin fines de lucro, creada en el
                2014, que concentra sus actividades en la promoción del
                pensamiento crítico y la formación de una ciudadanía con valores
                democráticos. Su trabajo, de marcada vocación formativa, se
                desarrolla en dos líneas fundamentales: el periodismo, la
                democracia y la política; y la educación y la formación
                ciudadana.
              </p>
              <p>
                La fundación mantiene un estrecho vínculo con los medios del
                Grupo La República y establece alianzas con importantes
                instituciones peruanas e internacionales, tales como
                universidades, centros de educación básica, organizaciones de la
                sociedad civil, gremios y distintos organismos del Estado.
                Mediante este trabajo, la fundación busca difundir los valores
                inspirados en la memoria de don Gustavo Mohme Llona y continuar
                con su legado trabajando por el bien común y el desarrollo
                integral de la nación, por una sociedad más justa, honesta y
                equitativa.
              </p>
              <p>
                La fundación lleva el nombre de Gustavo Mohme Llona, empresario,
                político, activista social y director fundador del diario{" "}
                <em>La República</em>, quien a lo largo de su vida se distinguió
                como una persona coherente con los valores democráticos de
                libertad, solidaridad, justicia y verdad. Nuestra organización
                se inspira en sus ideales y ha sido creada para continuar su
                legado.
              </p>
              <div className="mision bg-red-dark">
                <p>
                  Nuestra misión: Impulsar que la libertad de información y la
                  educación, entendidas como ejercicios y derechos ciudadanos,
                  estén al servicio de la construcción de una sociedad tolerante
                  y responsable.
                </p>
                <div className="block-bottom"></div>
              </div>

              <figure className="img-center">
                <div className="block-red"></div>
                <img
                  src={Familia}
                  alt="Familia de Gustavo Mohme Llona reunida en la presentación de su biografía."
                  className=""
                />
                <div className="legend">
                  Familia de Gustavo Mohme Llona reunida en la presentación de
                  su biografía.
                </div>
              </figure>
              <div className="mision bg-red-dark">
                <p>
                  Nuestra visión: Consolidar nuestros proyectos, inspirados en
                  el legado de Gustavo Mohme Llona, para impactar positivamente
                  en la sociedad en el corto, mediano y largo plazo.
                </p>
                <div className="block-bottom"></div>
              </div>
            </Fade>
          </div>
        </div>
      </div>
      <div className="equipo bg-red">
        <div className="container">
          <div className="container-text">
            <Fade delay={100} triggerOnce damping={0.05} fraction={0} cascade>
              <h4>NUESTRO EQUIPO</h4>
              <p>
                La fundación se organiza en grupos de trabajo que cumplen
                funciones directivas, ejecutivas y administrativas
                complementarias. Estos están conformados por las siguientes
                personas:
              </p>
              <h5>Junta administrativa</h5>
              <div className="col-3">
                <div>
                  <img src={StellaMohme} alt="Stella Mohme" />
                  <p>Stella Mohme</p>
                </div>
                <div>
                  <img src={HelenaMohme} alt="Helena Mohme" />
                  <p>Helena Mohme</p>
                </div>
                <div>
                  <img src={ClaudiaCornejo} alt="Claudia Cornejo" />
                  <p>Claudia Cornejo</p>
                </div>
              </div>
              <div className="d-flex">
                <div className="col-1">
                  <h5>Asesor principal</h5>
                  <img src={Edmundo} alt="Edmundo Cruz" />
                  <p>Edmundo Cruz</p>
                </div>
                <div className="col-2">
                  <h5>Equipo de trabajo</h5>
                  <div className="d-flex">
                    <div className="col-2-item">
                      <img src={Rivero} alt="Claudia Rivero" />
                      <p>Claudia Rivero</p>
                    </div>
                    <div className="col-2-item">
                      <img src={Wilber} alt="Wilber Huacasi" />
                      <p>Wilber Huacasi</p>
                    </div>
                    <div className="col-2-item">
                      <img src={Melissa} alt="Melissa Chávez" />
                      <p>Melissa Chávez</p>
                    </div>
                    <div className="col-2-item">
                      <img src={Ricardo} alt="Ricardo Guerrero" />
                      <p>Ricardo Guerrero</p>
                    </div>
                    <div className="col-2-item">
                      <img src={Claudia} alt="Claudia Fernández" />
                      <p>Claudia Fernández</p>
                    </div>
                  </div>
                </div>
              </div>
              <h5>Consejo consultivo</h5>
              <div className="col-3">
                <div>
                  <img src={Hernan} alt="Hernán Lanzara" />
                  <p>Hernán Lanzara</p>
                </div>
                <div>
                  <img src={Pepi} alt="Pepi Patrón" />
                  <p>Pepi Patrón</p>
                </div>
                <div>
                  <img src={Martin} alt="Martín Vegas" />
                  <p>Martín Vegas</p>
                </div>
                <div>
                  <img src={Ursula} alt="Úrsula Freundt-Thurne" />
                  <p>Úrsula Freundt-Thurne</p>
                </div>
                <div>
                  <img src={Aurelio} alt="Aurelio Loret de Mola" />
                  <p>Aurelio Loret de Mola</p>
                </div>
                <div>
                  <img src={Antonio} alt="Antonio Zapata*" />
                  <p>
                    Antonio Zapata <br />
                    (Miembro hasta el año 2018)
                  </p>
                </div>
              </div>
              <div className="mision bg-red-dark">
                <p>
                  Somos un equipo que tiene a la ética como un componente
                  transversal del trabajo, tanto en las iniciativas vinculadas
                  al periodismo como en las relacionadas con el sector
                  educación.
                </p>
              </div>
            </Fade>
          </div>
        </div>
      </div>
      <div className="container">
        <Navigation
          prev="https://fundacionmohme.org/especiales/memoria-2024/gustavo-mohme-llona"
          textPrev="1.1 Gustavo Mohme Llona (1930-2000)"
          next="https://fundacionmohme.org/especiales/memoria-2024/#periodismo"
          textNext="2. Eje Periodismo y Democracia"
        />
      </div>
    </section>
  );
};

export default fundacion;
